export default "__VITE_ASSET__kjL8bwNa__"